<template>
    <div>
        <div class="mb-6">
            <h6 class="has-text-grey is-uppercase">Quiz/Assessment Title</h6>
            <b-field>
                <b-input size="is-large" expanded v-model="component.title"/>
            </b-field>
        </div>

        <!-- CONTENT -->
        <b-collapse animation="slide">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Questions & Content</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <content-blocks :blocks="component.content.content"/>
            </div>

        </b-collapse>

        <b-collapse animation="slide" class="mt-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <b-field><b-switch v-model="component.content.attributes.minScoreToggle">Require minimum quiz score before they can move on.</b-switch></b-field>
                <div class="columns" v-if="component.content.attributes.minScoreToggle">
                    <div class="column is-3 is-offset-1">
                        <b-field message="Percent Correct (0-100)"><b-input type="number" min="1" max="100" v-model="component.content.attributes.minScore"></b-input></b-field>
                    </div>
                </div>
                <b-field><b-switch v-model="component.content.attributes.quizPassReveal">On quiz pass, show correct answers to missed questions.</b-switch></b-field>
                <b-field><b-switch v-model="component.content.attributes.quizFailReveal">On quiz fail, show correct answers to missed questions.</b-switch></b-field>
                <b-field><b-switch v-model="component.content.attributes.quizRetryResetCorrect">On quiz retry, reset correct questions so they must be answered again.</b-switch></b-field>
                <b-field><b-switch v-model="component.content.attributes.quizRetryResetIncorrect">On quiz retry, reset incorrect questions so they must be answered again.</b-switch></b-field>

                <b-field><b-switch v-model="require_approval" true-value="1" false-value="0">Once complete, require additional approval before they can move on.</b-switch></b-field>
                <b-field><b-switch v-model="require_signature" true-value="1" false-value="0">Require a signature agreeing to a condition before completing.</b-switch></b-field>
            </div>
        </b-collapse>

    </div>

</template>

<script>
    import ContentBlocks from "../ContentBlocks.vue";


    export default {
        components: {ContentBlocks},
        props: ['component'],
        data: function() {
            return {
                content: {},
                reqTimeToggle: false,
                reqScoreToggle: false,
                require_min_time: 0,
                require_approval: false,
                require_signature: false
            };
        }
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
